import { Client } from '@shared/entities/client';
import { EntityType, StateIcons, TableConfigurationType } from './types';

export const TABLE_CONFIGURATION: TableConfigurationType = {
  machines: {
    sorting_criteria: [
      { id: 'installDate', value: 'installDate' },
      { id: 'state', value: 'state' },
      { id: 'typology', value: 'typology' },
      { id: 'serialNumber', value: 'serialNumber' },
      { id: 'location', value: 'location' }
    ],
    showHeading: true,
    headings: [
      {
        key: 'statusValue' as keyof EntityType,
        icon: true,
        classlist: 'text-uppercase',
        pipe: null,
        needsTranslation: true,
        translationPrefix: 'STATUSES'
      },
      {
        key: 'serialNumber' as keyof EntityType,
        icon: false,
        classlist: '',
        pipe: null
      },
      {
        key: 'assetName' as keyof EntityType,
        icon: false,
        classlist: 'fw-semibold',
        pipe: null
      },
      {
        key: 'typology' as keyof EntityType,
        icon: false,
        classlist: '',
        pipe: null
      },
      {
        key: 'location' as keyof EntityType,
        icon: false,
        classlist: '',
        pipe: null,
        truncate: {
          maxChars: { default: 20, md: 15 },
          singleLine: true
        }
      },
      {
        key: 'installDate' as keyof EntityType,
        icon: false,
        classlist: 'fw-semibold',
        pipe: null,
        isDate: true
      }
    ],
    available_filters: ['state', 'serialNumber', 'location', 'typology', 'orderBy'],
    hasButton: true,
    btnAction: 'openDetails',
    css: {
      table: {
        column_widths: [12, 12, 15, 12, 16, 15],
        main: 'main-table-row',
        thead: 'no-background',
        tbody: '',
        buttonShow: 'button-show',
        buttonHide: 'button-hide border-0',
        striped: false,
        simple: false
      }
    },
    details: [
      {
        icon: 'informations',
        tabName: 'informations'
      },
      {
        icon: 'performances',
        tabName: 'performances'
      }
    ]
  },
  machines_performance: {
    sorting_criteria: null,
    showHeading: true,
    // headings: [
    //   'date_period',
    //   'total_missions',
    //   'picking_missions',
    //   'picking_missions_time',
    //   'refilling_missions',
    //   'refilling_missions_time',
    //   'execution_time'
    // ],
    headings: [
      {
        key: 'period' as keyof EntityType,
        icon: false,
        classlist: '',
        pipe: null,
        isDate: true,
        defaultMessaggeIfEmpty: 'STATUSES.NOT_AVAILABLE'
      },
      {
        key: 'totalMissions' as keyof EntityType,
        icon: false,
        classlist: '',
        pipe: null
      },
      {
        key: 'pickingMissions' as keyof EntityType,
        icon: false,
        classlist: 'text-accent-blue fw-semibold',
        pipe: null
      },
      {
        key: 'pickingMissionsHour' as keyof EntityType,
        icon: false,
        classlist: '',
        pipe: null
      },
      {
        key: 'refillingMissions' as keyof EntityType,
        icon: false,
        classlist: 'text-accent-yellow fw-semibold',
        pipe: null
      },
      {
        key: 'refillingMissionsHour' as keyof EntityType,
        icon: false,
        classlist: '',
        pipe: null
      },
      {
        key: 'execTimeInHours' as keyof EntityType,
        icon: false,
        classlist: '',
        pipe: null
      }
    ],
    available_filters: ['date_period', 'custom_period'],
    hasButton: false,
    btnAction: 'openDetails',
    css: {
      table: {
        column_widths: [13, 13, 13, 15, 15, 15, 15],
        main: 'table-striped-row',
        thead: 'no-background',
        tbody: 'table-striped-with-padding',
        buttonShow: 'underlined-text',
        buttonHide: 'underlined-text',
        striped: true,
        simple: false
      }
    }
  },
  open_tickets: {
    sorting_criteria: [
      { id: 'MOST_RECENT', value: 'most_recent' },
      { id: 'OLDEST', value: 'oldest' }
    ],
    showHeading: true,
    // headings: ['status', 'id', 'serialNumber', 'createdDate', 'description'],
    headings: [
      {
        key: 'status' as keyof EntityType,
        icon: true,
        classlist: '',
        pipe: null,
        needsTranslation: true,
        translationPrefix: 'STATUSES'
      },
      {
        key: 'caseNumber' as keyof EntityType,
        icon: false,
        classlist: '',
        pipe: null
      },
      {
        key: 'serialNumber' as keyof EntityType,
        icon: false,
        classlist: 'fw-semibold',
        pipe: null
      },
      {
        key: 'createdDate' as keyof EntityType,
        icon: false,
        classlist: '',
        pipe: null,
        isDate: true
      },
      {
        key: 'description' as keyof EntityType,
        icon: true,
        classlist: 'justify-content-between',
        pipe: null,
        defaultMessaggeIfEmpty: 'TABLE.DEFAULT_MESSAGES_IF_EMPTY.TICKET_DESCRIPTION',
        defaultIcon: 'attachment',
        iconAfter: true
      }
    ],
    available_filters: [],
    hasButton: false,
    btnAction: 'routerLink',
    route: 'request/new/:id_ticket/:serialNumber',
    css: {
      table: {
        column_widths: [20, 18, 18, 20, 20],
        main: 'main-table-row machine-performaces-table',
        thead: 'no-background',
        tbody: '',
        buttonShow: 'button-show',
        buttonHide: 'button-hide',
        striped: false,
        simple: false
      }
    }
  },
  closed_tickets: {
    sorting_criteria: [
      { id: 'MOST_RECENT', value: 'most_recent' },
      { id: 'OLDEST', value: 'oldest' }
    ],
    showHeading: true,
    // headings: ['id', 'serialNumber', 'createdDate', 'closedDate', 'description', 'isClosed'],
    headings: [
      {
        key: 'caseNumber' as keyof EntityType,
        icon: false,
        classlist: '',
        pipe: null
      },
      {
        key: 'serialNumber' as keyof EntityType,
        icon: false,
        classlist: 'fw-semibold',
        pipe: null
      },
      {
        key: 'createdDate' as keyof EntityType,
        icon: false,
        classlist: '',
        pipe: null,
        isDate: true
      },
      {
        key: 'closedDate' as keyof EntityType,
        icon: false,
        classlist: '',
        pipe: null,
        isDate: true
      },
      {
        key: 'description' as keyof EntityType,
        icon: true,
        classlist: '',
        pipe: null,
        defaultMessaggeIfEmpty: 'TABLE.DEFAULT_MESSAGES_IF_EMPTY.TICKET_DESCRIPTION',
        defaultIcon: 'attachment'
      },
      {
        key: 'status' as keyof EntityType,
        icon: true,
        classlist: 'text-accent-green',
        pipe: null,
        needsTranslation: true,
        translationPrefix: 'STATUSES'
      }
    ],
    hasButton: true,
    btnAction: 'openDetails',
    css: {
      table: {
        column_widths: [13, 13, 14, 14, 14, 14],
        main: 'table-striped-row',
        thead: 'no-background',
        tbody: 'table-striped-with-padding',
        buttonShow: 'underlined-text',
        buttonHide: 'underlined-text',
        detailsPosition: '48%',
        striped: true,
        simple: false
      }
    },
    available_filters: ['caseNumber', 'serialNumber', 'orderBy']
  },
  requests: {
    sorting_criteria: [
      { id: 'MOST_RECENT', value: 'most_recent' },
      { id: 'OLDEST', value: 'oldest' }
    ],
    showHeading: true,
    headings: [
      {
        key: 'caseNumber' as keyof EntityType,
        icon: false,
        classlist: '',
        pipe: null
      },
      {
        key: 'createdDate' as keyof EntityType,
        icon: false,
        classlist: '',
        pipe: null,
        isDate: true
      },
      {
        key: 'serialNumber' as keyof EntityType,
        icon: false,
        classlist: '',
        pipe: null
      },
      {
        key: 'reason' as keyof EntityType,
        icon: true,
        classlist: 'justify-content-between',
        pipe: null,
        defaultIcon: 'attachment',
        needsTranslation: true,
        iconAfter: true
      }
    ],
    hasButton: true,
    btnAction: 'openDetails',
    css: {
      table: {
        column_widths: [19, 20, 19, 19],
        main: 'main-table-row',
        thead: 'no-background',
        tbody: '',
        buttonShow: 'button-show',
        buttonHide: 'button-hide border-0',
        detailsPosition: '39%',
        striped: false,
        simple: false
      }
    },
    // TODO missing createdDate
    available_filters: ['caseNumber', 'createdDate', 'serialNumber', 'reason', 'orderBy']
  },
  final_users: {
    sorting_criteria: [
      { id: 'INSTALLATION_DATE', value: 'installation_date' },
      { id: 'STATE', value: 'state' },
      { id: 'TYPE', value: 'type' },
      { id: 'NUMBER', value: 'number' },
      { id: 'LOCATIONS', value: 'locations' }
    ],
    showHeading: true,
    headings: [
      {
        key: 'name' as keyof EntityType,
        icon: true,
        classlist: 'fw-semibold',
        pipe: null,
        defaultIcon: 'user'
      },
      {
        key: 'location' as keyof EntityType,
        icon: false,
        classlist: '',
        pipe: null
      }
    ],
    available_filters: ['name', 'location'],
    hasButton: true,
    btnAction: 'routerLink',
    route: 'final-user-dashboard',
    queryParams: ['locationId', 'name'],
    onRouteClickCB: (finalUserSelected: Client, profile) => {
      localStorage.setItem(`${LAST_FINAL_USER_SEEN_KEY_STORAGE}_${profile.id}`, JSON.stringify(finalUserSelected));
    },
    css: {
      table: {
        column_widths: [31, 31],
        main: 'table-striped-row',
        thead: 'no-background',
        tbody: 'table-striped-with-padding',
        buttonShow: 'button-show',
        buttonHide: 'button-hide',
        striped: true,
        simple: false
      }
    }
  },
  last_final_user: {
    sorting_criteria: [
      { id: 'INSTALLATION_DATE', value: 'installation_date' },
      { id: 'STATE', value: 'state' },
      { id: 'TYPE', value: 'type' },
      { id: 'NUMBER', value: 'number' },
      { id: 'LOCATIONS', value: 'locations' }
    ],
    showHeading: false,
    headings: [
      {
        key: 'name' as keyof EntityType,
        icon: true,
        classlist: 'fw-semibold',
        pipe: null,
        defaultIcon: 'user'
      },
      {
        key: 'location' as keyof EntityType,
        icon: false,
        classlist: '',
        pipe: null
      }
    ],
    available_filters: [],
    hasButton: true,
    btnAction: 'routerLink',
    route: 'final-user-dashboard',
    queryParams: ['locationId', 'name'],
    css: {
      table: {
        column_widths: [30, 55],
        main: 'main-table-row',
        thead: 'no-background',
        tbody: '',
        buttonShow: 'button-show',
        buttonHide: 'button-hide',
        striped: false,
        simple: false
      }
    }
  },
  user: {
    sorting_criteria: [
      { id: 'email', value: 'email' },
      { id: 'createdDate', value: 'createdDate' },
      { id: 'modifiedDate', value: 'modifiedDate' }
    ],
    showHeading: true,
    headings: [
      {
        key: 'status' as keyof EntityType,
        icon: true,
        iconOnly: true,
        classlist: '',
        pipe: null,
        needsTranslation: true,
        translationPrefix: 'STATUSES'
      },
      {
        key: 'email' as keyof EntityType,
        icon: false,
        classlist: 'fw-semibold',
        pipe: null,
        utils: [
          // {
          //   icon: 'copy',
          //   title: 'Copy email',
          //   actionType: 'callback',
          //   onClick: (row: any) => {
          //     const text = row?.email || '';
          //     if (text && navigator?.clipboard) navigator.clipboard.writeText(text);
          //   }
          // },
          // {
          //   icon: 'mail',
          //   title: 'Send email',
          //   actionType: 'callback',
          //   onClick: (row: any) => {
          //     const email = row?.email || '';
          //     if (email) {
          //       window.location.href = `mailto:${email}`;
          //     }
          //   }
          // }
        ]
      },
      {
        key: 'lastName' as keyof EntityType,
        icon: false,
        classlist: 'fw-semibold',
        pipe: null,
        compose: {
          keys: ['lastName' as keyof EntityType, 'firstName' as keyof EntityType],
          headerTemplate: '${lastName} ${COMMON.CONJUNCTION.AND} ${firstName}',
          template: '${lastName} ${firstName}',
          translateInHeader: true,
          trimResult: true
        },
        truncate: {
          maxChars: { default: 20 },
          singleLine: true
        }
      },
      {
        key: 'machines.serialNumber' as keyof EntityType,
        icon: false,
        classlist: '',
        pipe: null,
        isArray: true,
        arrayDisplayType: 'comma-separated',
        utils: [
          // {
          //   icon: 'copy',
          //   title: 'Copy serial numbers',
          //   actionType: 'callback',
          //   onClick: (row: any) => {
          //     console.log('row', row);
          //     const text = row?.machines?.flatMap((m: any) => m.serialNumber).join(', ') || '';
          //     if (text && navigator?.clipboard) navigator.clipboard.writeText(text);
          //   }
          // }
        ]
      },
      {
        key: 'machines.accountName' as keyof EntityType,
        icon: false,
        classlist: '',
        pipe: null,
        isArray: true,
        arrayDisplayType: 'comma-separated'
      }
    ],
    available_filters: ['keyword', 'status', 'serialNumber', 'accounts', 'orderBy'],
    hasButton: true,
    btnAction: 'routerLink',
    route: 'user/:id',
    css: {
      table: {
        column_widths: [5, 24, 19, 19, 18],
        main: 'main-table-row',
        thead: 'no-background',
        tbody: '',
        buttonShow: 'button-show',
        buttonHide: '',
        striped: false,
        simple: true
      }
    }
  },
  partner: {
    sorting_criteria: [
      { id: 'EMAIL', value: 'email' },
      { id: 'CREATED_DATE', value: 'created_date' },
      { id: 'MODIFIED_DATE', value: 'modified_date' }
    ],
    showHeading: true,
    headings: [
      {
        key: 'status' as keyof EntityType,
        icon: true,
        iconOnly: true,
        classlist: '',
        pipe: null,
        needsTranslation: true,
        translationPrefix: 'STATUSES'
      },
      {
        key: 'email' as keyof EntityType,
        icon: false,
        classlist: 'fw-semibold',
        pipe: null
      },
      {
        key: 'accounts.name' as keyof EntityType,
        icon: false,
        classlist: '',
        pipe: null,
        isArray: true,
        arrayDisplayType: 'comma-separated'
      }
    ],
    available_filters: ['keyword', 'status', 'accounts', 'orderBy'],
    hasButton: true,
    btnAction: 'routerLink',
    route: 'user/:id',
    css: {
      table: {
        column_widths: [4, 35, 35],
        main: 'main-table-row',
        thead: 'no-background',
        tbody: '',
        buttonShow: 'button-show',
        buttonHide: '',
        striped: false,
        simple: true
      }
    }
  },
  sales_order: {
    sorting_criteria: [
      { id: 'SALES_ORDER_NUMBER', value: 'salesOrderNumber' },
      { id: 'CREATED_DATE', value: 'createdDate' },
      { id: 'ACCOUNT_ID', value: 'accountId' }
    ],
    showHeading: true,
    headings: [
      {
        key: 'salesOrderNumber' as keyof EntityType,
        icon: false,
        classlist: 'fw-semibold',
        pipe: null
      },
      {
        key: 'accountName' as keyof EntityType,
        icon: false,
        classlist: 'fw-semibold',
        pipe: null
      },
      {
        key: 'machineInfos.serialNumber' as keyof EntityType,
        icon: false,
        classlist: '',
        pipe: null,
        isArray: true,
        arrayDisplayType: 'comma-separated',
        truncate: {
          maxChars: { default: 20 },
          singleLine: true
        }
      },
      {
        key: 'createdDate' as keyof EntityType,
        icon: false,
        classlist: '',
        pipe: null,
        isDate: true
      }
    ],
    available_filters: ['accountName', 'serialNumbers', 'orderBy'],
    hasButton: true,
    btnAction: 'routerLink',
    hasSecondaryButton: true,
    secondaryBtnAction: 'download',
    secondaryDownloadIdProperty: 'attachmentId',
    route: 'repository/sales-order/:id/documents',
    css: {
      table: {
        column_widths: [20, 18, 20, 20],
        main: 'main-table-row',
        thead: 'no-background',
        tbody: '',
        buttonShow: 'button-show',
        buttonDownload: 'button-download',
        buttonHide: '',
        striped: false,
        simple: true
      }
    }
  },
  required_document: {
    sorting_criteria: [{ id: 'createdDate', value: 'createdDate' }],
    showHeading: true,
    headings: [
      {
        key: 'displayOrder' as keyof EntityType,
        icon: false,
        classlist: '',
        pipe: null,
        needsTranslation: false
      },
      {
        key: 'reqDocName' as keyof EntityType,
        icon: false,
        classlist: '',
        pipe: null,
        needsTranslation: false
      },
      {
        key: 'customerCanUpload' as keyof EntityType,
        icon: false,
        classlist: '',
        pipe: null,
        needsTranslation: false
      },
      {
        key: 'associatedToMachine' as keyof EntityType,
        icon: false,
        classlist: '',
        pipe: null,
        needsTranslation: false
      },
      {
        key: 'active' as keyof EntityType,
        icon: false,
        classlist: '',
        pipe: null,
        needsTranslation: false
      }
    ],
    available_filters: ['active', 'customerCanUpload', 'associatedToMachine', 'orderBy'],
    hasButton: true,
    btnAction: 'routerLink',
    route: 'repository/required-documents/:id',
    css: {
      table: {
        column_widths: [15, 25, 15, 15, 15],
        main: 'main-table-row',
        thead: 'no-background',
        tbody: '',
        buttonShow: 'button-show',
        buttonHide: '',
        striped: false,
        simple: true
      }
    }
  },
  banner: {
    sorting_criteria: [
      { id: 'startDate', value: 'startDate' },
      { id: 'endDate', value: 'endDate' },
      { id: 'createdDate', value: 'createdDate' },
      { id: 'modifiedDate', value: 'modifiedDate' }
    ],
    showHeading: true,
    headerPrefix: 'banner',
    headings: [
      {
        key: 'description' as keyof EntityType,
        icon: false,
        classlist: 'fw-semibold',
        pipe: null,
        needsTranslation: true
      },
      {
        key: 'startDate' as keyof EntityType,
        icon: false,
        classlist: '',
        pipe: null,
        isDate: true
      },
      {
        key: 'endDate' as keyof EntityType,
        icon: false,
        classlist: '',
        pipe: null,
        isDate: true
      },
      {
        key: 'geoLocation' as keyof EntityType,
        icon: false,
        classlist: '',
        pipe: null,
        isArray: true,
        arrayDisplayType: 'comma-separated'
      },
      {
        key: 'operatingSectorList' as keyof EntityType,
        icon: false,
        classlist: '',
        pipe: null,
        isArray: true,
        arrayDisplayType: 'comma-separated',
        needsTranslation: true
      }
    ],
    available_filters: ['keyword', 'geoLocation', 'operatingSector', 'date', 'orderBy'],
    hasButton: true,
    btnAction: 'routerLink',
    route: 'banner/:id',
    css: {
      table: {
        column_widths: [16, 16, 16, 16, 16],
        main: 'main-table-row',
        thead: 'no-background',
        tbody: '',
        buttonShow: 'button-show',
        buttonHide: '',
        striped: false,
        simple: true
      }
    }
  },
  sales_order_documents: {
    sorting_criteria: [],
    showHeading: true,
    headings: [
      {
        key: 'status' as keyof EntityType,
        icon: false,
        classlist: '',
        pipe: null
      },
      {
        key: 'sodName' as keyof EntityType,
        icon: false,
        classlist: 'fw-semibold',
        pipe: null
      },
      {
        key: 'modifiedDate' as keyof EntityType,
        icon: false,
        classlist: '',
        pipe: null,
        isDate: true
      }
    ],
    available_filters: [],
    hasButton: true,
    btnAction: 'routerLink',
    route: 'repository/sales-order-documents/:id/form',
    hasSecondaryButton: true,
    secondaryBtnAction: 'download',
    secondaryDownloadIdProperty: 'attachmentId',
    hasTertiaryButton: true,
    tertiaryBtnAction: 'delete',
    css: {
      table: {
        column_widths: [22, 26, 24],
        main: 'main-table-row',
        thead: 'no-background',
        tbody: '',
        buttonShow: 'button-show',
        buttonDownload: 'button-download',
        buttonDelete: 'button-delete',
        buttonHide: '',
        striped: false,
        simple: true
      }
    }
  },
  legal_documents: {
    sorting_criteria: [],
    showHeading: true,
    headings: [
      {
        key: 'type' as keyof EntityType,
        icon: false,
        classlist: 'fw-semibold',
        pipe: null,
        needsTranslation: true,
        translationPrefix: 'LEGAL_DOCUMENTS.TYPES'
      },
      {
        key: 'lang' as keyof EntityType,
        icon: false,
        classlist: '',
        pipe: null
      },
      {
        key: 'modifiedDate' as keyof EntityType,
        icon: false,
        classlist: '',
        pipe: null,
        isDate: true
      }
    ],
    available_filters: [],
    hasButton: true,
    btnAction: 'routerLink',
    route: 'legal-documents/:id',
    hasSecondaryButton: true,
    secondaryBtnAction: 'download',
    secondaryDownloadIdProperty: 'attachmentId',
    hasTertiaryButton: false,
    css: {
      table: {
        column_widths: [34, 16, 30],
        main: 'main-table-row',
        thead: 'no-background',
        tbody: '',
        buttonShow: 'button-show',
        buttonDownload: 'button-download',
        buttonHide: '',
        striped: false,
        simple: true
      }
    }
  },
  learning: {
    sorting_criteria: [{ id: 'createdDate', value: 'createdDate' }],
    showHeading: true,
    headings: [
      {
        key: 'title' as keyof EntityType,
        icon: false,
        classlist: '',
        pipe: null,
        needsTranslation: false
      },
      {
        key: 'complexity' as keyof EntityType,
        icon: false,
        classlist: '',
        pipe: null,
        needsTranslation: true,
        translationPrefix: 'COMMON.COMPLEXITY'
      },
      {
        key: 'machineTypes' as keyof EntityType,
        icon: false,
        classlist: '',
        pipe: null,
        isArray: true,
        arrayDisplayType: 'comma-separated',
        truncate: {
          maxChars: { default: 20 },
          singleLine: true
        },
        needsTranslation: false
      },
      {
        key: 'active' as keyof EntityType,
        icon: false,
        classlist: '',
        pipe: null,
        needsTranslation: false
      }
    ],
    available_filters: ['isFavorite', 'machineType', 'tag', 'complexity', 'orderBy'],
    hasButton: true,
    btnAction: 'routerLink',
    route: 'learning/:id',
    css: {
      table: {
        column_widths: [20, 15, 20, 10],
        main: 'main-table-row',
        thead: 'no-background',
        tbody: '',
        buttonShow: 'button-show',
        buttonHide: '',
        striped: false,
        simple: true
      }
    }
  },
  company_group: {
    sorting_criteria: null,
    showHeading: true,
    headerPrefix: 'company_group',
    headings: [
      {
        key: 'name' as keyof EntityType,
        icon: false,
        classlist: 'fw-semibold',
        pipe: null,
        needsTranslation: false
      },
      {
        key: 'description' as keyof EntityType,
        icon: false,
        classlist: '',
        pipe: null,
        needsTranslation: false,
        defaultMessaggeIfEmpty: 'STATUSES.NOT_AVAILABLE'
      }
    ],
    available_filters: [],
    hasButton: true,
    btnAction: 'routerLink',
    route: 'company-group/:id',
    css: {
      table: {
        column_widths: [40, 40],
        main: 'main-table-row',
        thead: 'no-background',
        tbody: '',
        buttonShow: 'button-show',
        buttonHide: '',
        striped: false,
        simple: true
      }
    }
  },
  company_group_user: {
    sorting_criteria: [
      { id: 'email', value: 'email' },
      { id: 'createdDate', value: 'createdDate' },
      { id: 'modifiedDate', value: 'modifiedDate' }
    ],
    showHeading: true,
    headings: [
      {
        key: 'status' as keyof EntityType,
        icon: true,
        iconOnly: true,
        classlist: '',
        pipe: null,
        needsTranslation: true,
        translationPrefix: 'STATUSES'
      },
      {
        key: 'email' as keyof EntityType,
        icon: false,
        classlist: 'fw-semibold',
        pipe: null
      },
      {
        key: 'lastName' as keyof EntityType,
        icon: false,
        classlist: 'fw-semibold',
        pipe: null,
        compose: {
          keys: ['lastName' as keyof EntityType, 'firstName' as keyof EntityType],
          headerTemplate: '${lastName} ${COMMON.CONJUNCTION.AND} ${firstName}',
          template: '${lastName} ${firstName}',
          translateInHeader: true,
          trimResult: true
        },
        truncate: {
          maxChars: { default: 20 },
          singleLine: true
        }
      },
      {
        key: 'machines.serialNumber' as keyof EntityType,
        icon: false,
        classlist: '',
        pipe: null,
        isArray: true,
        arrayDisplayType: 'comma-separated'
      },
      {
        key: 'machines.accountName' as keyof EntityType,
        icon: false,
        classlist: '',
        pipe: null,
        isArray: true,
        arrayDisplayType: 'comma-separated'
      }
    ],
    available_filters: ['keyword', 'status', 'serialNumber', 'accounts', 'orderBy'],
    hasButton: true,
    btnAction: 'routerLink',
    route: 'user/:id',
    css: {
      table: {
        column_widths: [5, 24, 19, 19, 18],
        main: 'main-table-row',
        thead: 'no-background',
        tbody: '',
        buttonShow: 'button-show',
        buttonHide: '',
        striped: false,
        simple: true
      }
    }
  },
  machine_modules: {
    sorting_criteria: [
      { id: 'serialNumber', value: 'serialNumber' },
      { id: 'typology', value: 'typology' },
      { id: 'location', value: 'location' }
    ],
    showHeading: true,
    headings: [
      {
        key: 'serialNumber' as keyof EntityType,
        icon: false,
        classlist: 'fw-semibold',
        pipe: null
      },
      {
        key: 'assetName' as keyof EntityType,
        icon: false,
        classlist: '',
        pipe: null
      },
      {
        key: 'accountName' as keyof EntityType,
        icon: false,
        classlist: '',
        pipe: null,
        truncate: {
          maxChars: { default: 20, md: 15 },
          singleLine: true
        }
      },
      {
        key: 'typology' as keyof EntityType,
        icon: false,
        classlist: '',
        pipe: null
      },
      {
        key: 'location' as keyof EntityType,
        icon: false,
        classlist: '',
        pipe: null,
        truncate: {
          maxChars: { default: 20, md: 15 },
          singleLine: true
        }
      }
    ],
    available_filters: ['accountName', 'serialNumber'],
    hasButton: true,
    btnAction: 'routerLink',
    route: 'machine-modules/:serialNumber',
    css: {
      table: {
        column_widths: [14, 18, 18, 15, 15],
        main: 'main-table-row',
        thead: 'no-background',
        tbody: '',
        buttonShow: 'button-show',
        buttonHide: '',
        striped: false,
        simple: true
      }
    }
  }
};

export const STATE_ICONS_MAPPING: StateIcons = {
  ko: 'KO',
  KO: 'KO',
  offline: 'OFFLINE',
  Offline: 'OFFLINE',
  OFFLINE: 'OFFLINE',
  ok: 'OK',
  OK: 'OK',
  ONLINE: 'ONLINE',
  online: 'ONLINE',
  Online: 'ONLINE',
  SUBMITTED: 'PRESO_IN_CARICO',
  PROCESSING: 'IN_LAVORAZIONE',
  CLOSED: 'OK',
  ND: 'PRESO_IN_CARICO',
  1: 'PRESO_IN_CARICO',
  6: 'PRESO_IN_CARICO',
  2: 'IN_LAVORAZIONE',
  3: 'IN_LAVORAZIONE',
  4: 'IN_LAVORAZIONE',
  7: 'IN_LAVORAZIONE',
  5: 'OK',
  ACTIVE: 'ONLINE',
  INACTIVE: 'OFFLINE',
  MISALIGNED: 'warning',
  true: 'OK',
  false: 'KO'
};

export const WARRANTY_ID = '1';
export const REPARATION_ID = '2';
export const MAINTENANCE_ID = '3';

export const LAST_FINAL_USER_SEEN_KEY_STORAGE = 'LAST_FINAL_USER_SEEN';

export const MAXLENGTH_TEXTAREA = 256;
